import { Dispatch } from 'redux'
import { set as setAction } from 'states/dux/theme/actions'
import { Action } from 'states/types'
import { NivosTheme } from 'types/theme'

type DispatchAction = (dispatch: Dispatch) => Action<NivosTheme>

const set = (theme: NivosTheme): DispatchAction => {
  return (dispatch: Dispatch): Action<NivosTheme> => dispatch(setAction(theme))
}

export interface Operations {
  set: (theme: NivosTheme) => DispatchAction
}

const operations: Operations = {
  set
}

export { operations, set }
